import { createAsyncThunk, createSlice, } from "@reduxjs/toolkit";
import { RootState } from "../../../Redux/store";

// const salesUrl = 'http://dev.customer.hirsch.local/order/v1/sales'
interface FetchSalesArgs {
	writerId?: string | null;
};

export const getSales = createAsyncThunk<SalesData, FetchSalesArgs, { state: RootState, rejectValue: string }>(
	'sales/getSales',
	async (args, { getState, rejectWithValue }) => {
		try {
			const params = new URLSearchParams();

			if (args?.writerId) params.append('writerId', args.writerId);

			const salesUrl = `https://customer.hirsch.com/order/v1/sales?${params.toString()}`
			const token = getState().auth.token

			if (!token) return rejectWithValue('No Token Found')

			const response = await fetch(salesUrl, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': btoa(`Bearer ${token}`)
				}
			})

			if (!response.ok) throw new Error('Failed to fetch')

			const json = await response.json()
			console.log(json)
			return json.data
		} catch (err: any) {
			console.log('getSales Error:', err)
			return rejectWithValue(err.message)
		}
	}
);

type MonthData = {
	ListOfMonths: (string | number)[];
}

type QuarterData = {
	ListOfQuarters: (string | number)[];
}

type AnnualData = {
	total?: number | string;
}

type SalesData = {
	Months: MonthData;
	Quarters: QuarterData;
	Annual: AnnualData;
}

interface salesState {
	salesArr: SalesData;
	loading: boolean;
	error: string | undefined | boolean | null;
}

const initialState: salesState = {
	salesArr: {
		Months: { ListOfMonths: [] },
		Quarters: { ListOfQuarters: [] },
		Annual: {},
	},
	loading: false,
	error: null,
}

const salesSlice = createSlice({
	name: 'sales',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getSales.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(getSales.fulfilled, (state, action) => {
				state.loading = false;
				state.salesArr = action.payload || {
					Months: { ListOfMonths: [] },
					Quarters: { ListOfQuarters: [] },
					Annual: {},
				};
			})
			.addCase(getSales.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload || 'Failed to fetch sales data';
			});
	},
});

export const salesReducer = salesSlice.reducer;

export const annualSales = (state: RootState) =>
	state.sales.salesArr?.Annual || {};

export const monthlySales = (state: RootState) =>
	state.sales.salesArr?.Months?.ListOfMonths || [];

export const quarterlySales = (state: RootState) =>
	state.sales.salesArr?.Quarters?.ListOfQuarters || [];